import mapConfig from '@/config/mapConfig'
import MapboxDirections from '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions'
import '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions.css'

var directions = new MapboxDirections({
	accessToken: mapConfig.ACCESS_TOKEN,
	unit: 'metric',
	profile: 'mapbox/walking'
})

export const getDistanceBetweenPoints = (start, end) => {
	directions.setOrigin(start)
	directions.setDestination(end)
	
	directions.on("route", e => {
		let routes = e.route
		console.log(routes.map(r => r))
		let distance = routes.map(r => r.distance)/1000
		console.log('Route distance: ' + distance + 'km')
	})
}